import { inject, Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { AffairModel } from '../../../core/models/affair.model'
import { AffairSearchResultModel } from '../../../core/models/affair-search-result.model'

@Injectable({
  providedIn: 'root',
})
export class AffairsService {
  private http = inject(HttpClient)
  private route = environment.planifyApiUrl

  constructor() {}

  getAffairById(affairId: string) {
    return this.http.get<AffairModel>(`${this.route}/affairs/${affairId}`)
  }

  /**
   * Recherche d'affaires existantes (min. 2 caractères, 15 résultats max).
   * L'API renvoie un tableau nu (JsonResource::withoutWrapping côté back).
   */
  searchAffairs(q: string) {
    return this.http.get<AffairSearchResultModel[]>(
      `${this.route}/affairs/search`,
      { params: { q } }
    )
  }

  getInterventions(affairId: string) {
    return this.http.get(`${this.route}/affairs/${affairId}/interventions`)
  }
  getTablotAffairs() {
    return this.http.get<any[]>(`${this.route}/tablot/affairs`)
  }
}
